import { GlobalOperations } from "../Common/GlobalOperations";
import { LoginControlByUserGuidResponse } from "../../Model/Response/ClientAgent/LoginControlByUserGuidResponse";
import { ApiBaseResponse } from "../../Model/Response/Common/ApiBaseResponse";
import { LoginControlByUserGuidRequest } from "../../Model/Request/ClientAgent/LoginControlByUserGuidRequest";
import { GetActiveSessionsOfAgentResponse } from "../../Model/Response/ClientAgent/GetActiveSessionsOfAgentResponse";
import { GetChatSessionDetailResponse } from "../../Model/Response/ClientAgent/GetChatSessionDetailResponse";
import { AssingHubIdToAlbUserRequest } from "../../Model/Request/ClientAgent/AssingHubIdToAlbUserRequest";
 
import { GetExistingWebChatReportsForAlbinaSoftAgentResponse } from "../../Model/Response/ClientAgent/GetExistingWebChatReportsForAlbinaSoftAgentResponse";
import { GetExistingWebChatReportsForAlbinaSoftAgentRequest } from "../../Model/Request/ClientAgent/GetExistingWebChatReportsForAlbinaSoftAgentRequest";
import { AddChatSessionToExistingReportRequest } from "../../Model/Request/ClientAgent/AddChatSessionToExistingReportRequest";
import { ReportChatSessionRequest } from "../../Model/Request/ClientAgent/ReportChatSessionRequest";
 

export async function LoginControlByUserGuid(request: LoginControlByUserGuidRequest): Promise<ApiBaseResponse<LoginControlByUserGuidResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "api/AlbinaSoftCMYonetim/LoginControlByUserGuid",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<LoginControlByUserGuidResponse> = await response.json();
    return data;
}


export async function GetActiveSessionsOfAgent(): Promise<ApiBaseResponse<GetActiveSessionsOfAgentResponse> | null> {


    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/GetActiveSessionsOfAgent",
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken
            }
        });

    let data: ApiBaseResponse<GetActiveSessionsOfAgentResponse> = await response.json();
    return data;
}

export async function GetChatSessionDetail(SessionId: number): Promise<ApiBaseResponse<GetChatSessionDetailResponse> | null> {

    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/GetChatSessionDetail/" + SessionId,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken
            }
        });

    let data: ApiBaseResponse<GetChatSessionDetailResponse> = await response.json();
    return data;
}

export async function AssingHubIdToAlbUser(request: AssingHubIdToAlbUserRequest): Promise<ApiBaseResponse<null> | null> {

    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/AssingHubIdToAlbUser",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken

            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<null> = await response.json();
    return data;
}


export async function ReportChatSession(request: ReportChatSessionRequest): Promise<ApiBaseResponse<null> | null> {

    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/ReportChatSession",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken

            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<null> = await response.json();
    return data;
}


export async function GetExistingWebChatReportsForAlbinaSoftAgent(request: GetExistingWebChatReportsForAlbinaSoftAgentRequest): Promise<ApiBaseResponse<GetExistingWebChatReportsForAlbinaSoftAgentResponse> | null> {

    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/GetExistingWebChatReportsForAlbinaSoftAgent",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken

            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<GetExistingWebChatReportsForAlbinaSoftAgentResponse> = await response.json();
    return data;
}


export async function AddChatSessionToExistingReport(request: AddChatSessionToExistingReportRequest): Promise<ApiBaseResponse<null> | null> {

    if (GlobalOperations.UserToken === null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/Chat/AddChatSessionToExistingReport",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': GlobalOperations.UserToken

            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<null> = await response.json();
    return data;
}